import { Player } from '@xing-com/crate-video-player';

import { Styled } from './styles';

type ArticleCoverVideoProps = {
  videoRef?: string;
  caption?: string;
};

const ArticleCoverVideo: React.FC<ArticleCoverVideoProps> = ({
  videoRef,
  caption,
}) => {
  if (!videoRef) {
    return null;
  }

  return (
    <Styled.HeaderVideoContainer data-qa="article-cover-video">
      <Player id={videoRef} section="article-cover" />
      {caption ? (
        <Styled.HeaderVideoCaption>{caption}</Styled.HeaderVideoCaption>
      ) : null}
    </Styled.HeaderVideoContainer>
  );
};

export default ArticleCoverVideo;
